<template>
    <div>
        <div id="payPwd">
            <input ref="pwd" type="text" maxlength="4" v-model="msg"  style="position: absolute;z-index: -1;left:-100%;opacity: 0"/>
            <ul class="pwd-wrap" @click="focus">
            <input type="text" :value="msgArray[0]" :placeholder="msgLength==0?basicDiscount[0]:''"  class="img_input">
            <input type="text" :value="msgArray[1]" :placeholder="msgLength==0?basicDiscount[1]:''" class="img_input">
            <input type="text" :value="msgArray[2]" :placeholder="msgLength==0?basicDiscount[2]:''" class="img_input">
            <input type="text" :value="msgArray[3]" :placeholder="msgLength==0?basicDiscount[3]:''" class="img_input">
            <input type="text" placeholder="折" class="img_input">
            </ul>
        </div>
        <p class="bottom">回收价: 
            <span class="number">{{price}}元  </span>
            <span v-show="showtext" class="tips">价格越低，回收越快</span> 
        </p>
    </div>  
</template>

<script>
export default {
    data(){
        return{
            msg:'',
            msgArray:[],
            msgLength:0,
        }
    },
    props:['discount', 'unitprice',],
    props:{
        discount:{
            type: [String, Number],
            default: 0
        },
        unitprice:[String, Number],
        showtext:{
            type: Boolean,
            default: true
        }
    },
    computed:{
        basicDiscount(){
            if(this.discount){
                let basicDiscount = this.discount;
                return basicDiscount.toString().split('')
            }
            else{
                return ['0', '0', '0', '0']
            }
        },
        price(){
            let priceResult = this.discount * this.unitprice /10000;
            if(this.msg.length == 4){
                priceResult = this.msg * this.unitprice /10000;
            }
            return priceResult.toFixed(2);
        }
    },
    methods:{
        //聚焦隐藏输入框
        focus(){
          this.$refs.pwd.focus();
        },
        //向父组件传新的折扣值
        sendNewDiscount(){
            this.$emit('update:discount', this.msg || this.discount.toString());
        },
        //清空已填折扣值
        clearDiscount(){
            this.msg = ''
        }
    },
    watch:{
        msg(curVal){
            if(/[^\d]/g.test(curVal)){
                this.msg = this.msg.replace(/[^\d]/g,'');
            }
            else{
                this.msgArray = this.msg.split('');
                this.msgLength = curVal.length;
            }
        },
    }
    
}
</script>

<style scoped lang="scss">
    .img_input{
        width: 48px;
        height: 48px;
        background: #F8F8F8;
        border-radius:5px;
        border: 1px solid #DDDDDD;
        font-size: 32px;
        text-align: center;
        color: #1A86FE;
        font-weight: bold;
    }
    .img_input::-webkit-input-placeholder{
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        color: #666666;
    }
    .img_input::-moz-placeholder{
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        color: #666666;
    }
    .img_input::-ms-input-placeholder{
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        color: #666666;
    }
    .bottom{
        color: #666666;
        margin: 20px 0;
        .number{
            font-size: 18px;
            color:#ed3f14;
            font-weight: 700;
        }
        .tips{
            color: var(--color);
            float: right;
            line-height: 30px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/discountInput.vue